
import React, {PureComponent} from 'react';
import classNames from "class-names";

const stubFunc = () => {};

class CustomInputClearifier extends PureComponent {

    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);

    }

    handleClear(event) {
        /*
        const aEvent = new Event('input', { bubbles: true });
        this.refs.input.value = "";
        this.refs.input.dispatchEvent(aEvent);
        this.refs.input.blur();

        this.invokeChange();
        */
        this.props.onClear();
    }

    handleChange(event) {
        this.invokeChange();
    }

    invokeChange() {
        this.props.onChange({
            target: this.refs.input,
        });
    }

    render() {

        return (
            <div className={classNames({
                "input-group": true,
                "input-group_controls": true,
                "input-group_show-clear": this.props.showClear,
                [this.props.additionalClassName || ""]: true,
            })}>
                <input ref="input"
                       name={this.props.name}
                       disabled={this.props.disabled}
                       placeholder={this.props.placeholder}
                       value={this.props.value}
                       onChange={this.handleChange}
                       onFocus={this.props.onFocus}
                       onBlur={this.props.onBlur}
                       onKeyPress={this.props.onKeyPress}
                       onTouchEnd={this.props.onTouchEnd || stubFunc}
                       onMouseUp={this.props.onMouseUp || stubFunc}
                       onCut={this.props.onCut || stubFunc}
                       onPaste={this.props.onPaste || stubFunc}
                       onCopy={this.props.onCopy || stubFunc}
                       className={classNames({
                           "form-control form-control_medium-font form-control-lg modal-form__input transparent-input form-control_clearing": true,
                           [this.props.additionalClassNameInput || ""]: true,
                       })}
                       autoComplete="off"
                       autoCorrect="off"
                       autoCapitalize="off"
                       spellCheck="false"
                       type={this.props.type}
                       readOnly={!!this.props.readOnly}
                />
                <button className="transparent-button ico-small-cross input-group__clear-button"
                        type="button"
                        disabled={this.props.disabled}
                        onClick={this.handleClear}></button>
            </div>
        );
    }
}

export default CustomInputClearifier;